var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowWithCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5565 15.2984C23.8602 15.6351 23.8602 16.1427 23.5565 16.4794L19.9486 20.4794C19.6177 20.8464 19.0476 20.8794 18.6753 20.5533C18.303 20.2271 18.2694 19.6653 18.6004 19.2984L20.8738 16.7778H8.90195C8.40381 16.7778 7.99999 16.3798 7.99999 15.8889C7.99999 15.398 8.40381 15 8.90195 15H20.8738L18.6004 12.4794C18.2694 12.1125 18.303 11.5507 18.6753 11.2245C19.0476 10.8984 19.6177 10.9314 19.9486 11.2984L23.5565 15.2984Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWithCircle);
export default __webpack_public_path__ + "static/media/right_arrow_with_circle.cb57cf05f3c22104559eb3213d25d773.svg";
export { ForwardRef as ReactComponent };